export const whiteListTable = (data = []) => {
    return (
        data &&
        data.length &&
        data.map((item, index) => {
            const { account_id, id, account_name, address } = item;

            return {
                rowId: index + 1,
                id: id,
                ip: address,
                account_name: account_name,
            };
        })
    );
};

export const whiteListTableTitles = () => {
    return [
        {
            title: "IP",
            alias: "ip",
        },
        {
            title: "Account",
            alias: "account",
        },
    ];
};
